import React, { useState } from 'react';
import { Button } from './Button';
import { Mail, CheckCircle } from 'lucide-react';
export function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
      setEmail('');
      // Reset success message after 5 seconds
      setTimeout(() => {
        setIsSubmitted(false);
      }, 5000);
    }, 1500);
  };
  return <section className="py-24 bg-sfrr-green relative overflow-hidden" data-id="element-224">
      {/* Decorative circles */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-white opacity-10 rounded-full -translate-x-1/2 -translate-y-1/2" data-id="element-225"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-white opacity-10 rounded-full translate-x-1/3 translate-y-1/3" data-id="element-226"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-227">
        <div className="max-w-4xl mx-auto bg-white rounded-3xl p-8 md:p-12 shadow-2xl flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-228">
          <div className="flex-1 text-center md:text-left" data-id="element-229">
            <div className="w-12 h-12 bg-sfrr-green/10 rounded-full flex items-center justify-center mb-6 mx-auto md:mx-0 text-sfrr-green" data-id="element-230">
              <Mail size={24} data-id="element-231" />
            </div>
            <h2 className="text-3xl font-bold text-charcoal mb-4" data-id="element-232">
              Join Our Community
            </h2>
            <p className="text-gray-600" data-id="element-233">
              Subscribe to receive updates on our latest projects, success
              stories, and opportunities to get involved.
            </p>
          </div>

          <div className="flex-1 w-full" data-id="element-234">
            {!isSubmitted ? <form onSubmit={handleSubmit} className="flex flex-col gap-4" data-id="element-235">
                <input type="email" placeholder="Enter your email address" value={email} onChange={e => setEmail(e.target.value)} required className="w-full px-6 py-4 rounded-xl border border-gray-200 focus:border-sfrr-green focus:ring-2 focus:ring-sfrr-green/20 outline-none transition-all bg-gray-50" data-id="element-236" />
                <Button variant="secondary" size="lg" fullWidth type="submit" isLoading={isSubmitting} disabled={isSubmitting} data-id="element-237">
                  {isSubmitting ? 'Subscribing...' : 'Subscribe Now'}
                </Button>
              </form> : <div className="bg-sfrr-green/10 rounded-xl p-6 text-center animate-fadeIn" data-id="element-238">
                <CheckCircle className="w-12 h-12 text-sfrr-green mx-auto mb-3" data-id="element-239" />
                <h3 className="text-xl font-bold text-charcoal mb-2" data-id="element-240">
                  Thank You!
                </h3>
                <p className="text-gray-600" data-id="element-241">
                  You've successfully subscribed to our newsletter.
                </p>
              </div>}
            {!isSubmitted && <p className="text-xs text-gray-400 mt-4 text-center md:text-left" data-id="element-242">
                We respect your privacy. Unsubscribe at any time.
              </p>}
          </div>
        </div>
      </div>
    </section>;
}